// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const PasswordSuccessMessage = styled.div`
  padding-bottom: 4rem;
`;
